import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=5f02bb0f&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=js&"
export * from "./AddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=5f02bb0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02bb0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f02bb0f')) {
      api.createRecord('5f02bb0f', component.options)
    } else {
      api.reload('5f02bb0f', component.options)
    }
    module.hot.accept("./AddDialog.vue?vue&type=template&id=5f02bb0f&scoped=true&", function () {
      api.rerender('5f02bb0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/navi/components/AddDialog.vue"
export default component.exports